<template>
  <div>
    <a
        class="a_link edit-icon-color" data-toggle="modal"
        data-target="#create_edit_customer_popup" href="#"
        @click="sendCustomerId"
        style="color:black !important;">
      <i class="fa fa-pencil ico_sty"></i>
    </a>
  </div>

</template>

<script>
import {EventBus} from "@/events/event-bus";

export default {
  name: "AddEditCustomerLink",
  props: ["customer"],
  data() {
    return {
      customer_id: this.customer.customer_id,
    }
  },
  methods:{
    sendCustomerId(){
      EventBus.$emit('setCustomerId', this.customer_id);
    },
  }
}
</script>
